import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('display_currency'),
    placeholder: defineMessage('select_currency_1'),
    resetButtonTitle: defineMessage('reset'),
};
